import { Link } from 'react-router';
import PropTypes from 'prop-types';

import { CHECKOUT_STEP_MAP, NEW_PAYMENT_STEP } from 'constants/checkoutFlow';

import ContentBox from 'components/checkout/caap/ContentBox';
import { Row, RowSpan } from 'components/checkout/caap/Layout';
import RightArrow from 'components/checkout/caap/RightArrow';

const AddNewPaymentMobile = ({ purchaseId }, { testId }) => (
  <ContentBox
    showOnlySmallScreen={true}
    isNonRadio={true}
    isLast={true}>
    <Link
      role="link" // eslint-disable-line jsx-a11y/no-noninteractive-element-to-interactive-role
      tabIndex="0"
      data-te="TE_CHECKOUT_PL_GO_TO_ADD_NEW"
      data-test-id={testId('enterNewCard')}
      to={`${CHECKOUT_STEP_MAP[NEW_PAYMENT_STEP]}?referrer=pay&pid=${purchaseId}`}>
      <Row>
        <RowSpan span="9">
          <strong>Add new payment</strong>
        </RowSpan>
        <RowSpan span="3">
          <RightArrow />
        </RowSpan>
      </Row>
    </Link>
  </ContentBox>
);

AddNewPaymentMobile.contextTypes = {
  testId: PropTypes.func
};

export default AddNewPaymentMobile;
